<template>
  <div class="box">
    <dl v-for='(item,index) in list' :key='index' v-if="list.length != 0">
      <dt><img :src="item.pic"></dt>
      <dd>
        <h3>{{item.title}}</h3>
        <p>{{item.subTitle}}</p>
        <router-link :to="{path:'/learning/detail',query:{id:item.id}}">查阅详情</router-link>
      </dd>
    </dl>
    <div style="text-align: center;margin-top: 35%;font-size: 20px;" v-if="list.length == 0">
         暂无信息
    </div>
  </div>
</template>

<script>
  import {
    news_list
  } from '@/axios/api.js'
  export default {
    data() {
      return {
        category: '',
        list: []
      }
    },
    methods: {
    },
    mounted() {
      this.category = localStorage.getItem("category");
      var data = {
        category : this.category,
        start: 0,
        type:53,
        count: 100
      }
      news_list(data).then(res => {
        if (res.data.code == 0) {
          // this.list = res.data.obj;
        } else {
          this.$message(res.data.msg);
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
</script>
<style scoped="scoped">
  .box{
    margin-top: 40px;
  }
  dl{
    height: 175px;
    box-shadow: 0px 1px 4px 0px rgba(0,21,41,0.12);
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;
  }
  dl dt{
    float: left;
    width: 175px;
    height: 130px;
    margin: 20px 0 0 20px;
    background: linear-gradient(90deg, #3A99FE 0%, #39C5FF 100%);
  }
  dl dt img{
    width: 100%;
    height: 100%;
  }
  dl dd{
    height: 100%;
    width: calc(100% - 195px);
    float: left;
    padding: 16px 30px 15px 27px;
    position:relative;
  }
  dl dd h3{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin-bottom: 15px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  dl dd p{
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    margin-bottom: 25px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  dl dd a{
    position: absolute;
    right: 30px;
    bottom: 25px;
    width: 104px;
    height: 32px;
    background: #2F935E;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/learning/introduction.vue